interface ComputerWithChecklistBehindSVGProps {
  color: string;
  style: React.CSSProperties;
}

const ComputerWithChecklistBehindSVG = ({
  color,
  style,
}: ComputerWithChecklistBehindSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
  >
    <g clipPath="url(#clip0_564_17651)">
      <path
        d="M24.5273 17.9307H2.97433C1.83773 17.9307 0.924194 18.8445 0.924194 19.958V36.1449C0.924194 37.2689 1.84835 38.1723 2.97433 38.1723H26.45C27.5866 38.1723 28.5001 37.2584 28.5001 36.1449V19.958C28.5001 18.834 27.576 17.9307 26.45 17.9307H24.5167"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.68009 38.1828L6.42664 41.313H14.7122H23.0083L21.7549 38.1828"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.3225 43.6975L28.7232 47.9832C29.0843 48.624 28.6169 49.4223 27.8734 49.4223H1.5721C0.828527 49.4223 0.361138 48.6345 0.722303 47.9832L3.12298 43.6975H26.3225Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.7122 16.0189V7.44749L21.6486 0.588242H49.4052V45.4622H30.7521"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.6735 22.9412L36.9662 26.8383L35.171 25.063"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.6735 35.1786L36.9662 39.0651L35.171 37.2899"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.6735 10.5462L36.9662 14.4433L35.171 12.6681"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.1251 3.37186V8.90757H17.5377"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_564_17651">
        <rect width="50" height="50" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default ComputerWithChecklistBehindSVG;
